import { BrandDisclosure } from '../types/BrandDisclosure';

// keyed by the lead channel `brand` values in Contentful
export const brandDisclosureByBrand: Record<string, BrandDisclosure> = {
  AUTOPAY: {
    name: 'AUTOPAY',
    privacyPolicyURL: 'https://www.autopay.com/privacy-policy',
    termsOfUseURL: 'https://www.autopay.com/terms',
  },
  RateGenius: {
    name: 'RateGenius',
    privacyPolicyURL: 'https://www.rategenius.com/privacy-policy',
    termsOfUseURL: 'https://www.rategenius.com/terms-of-use/',
  },
  Tresl: {
    name: 'Tresl',
    privacyPolicyURL: 'https://mytresl.com/privacy-policy/',
    termsOfUseURL: 'https://mytresl.com/terms-of-use/',
  },
};

export const defaultBrandDisclosure: BrandDisclosure = {
  name: 'The Savings Group',
  privacyPolicyURL: 'https://www.thesavingsgroup.com/privacy-policy/',
  termsOfUseURL: 'https://www.thesavingsgroup.com/terms-of-use/',
};
